export default "__VITE_ASSET__0ebb5b68__"